<template>
<div class="kqCountDlogBox">
    <div class="topCountHeader">
        <div class="countkk">
            <h3>{{ kkSum }}</h3>
            <div>旷课总次数</div>
        </div>
        <div class="countkk">
            <h3>{{ cdSum }}</h3>
            <div>迟到总次数</div>
        </div>
        <div class="countkk">
            <h3>{{ qjSum }}</h3>
            <div>请假总次数</div>
        </div>
        <div class="countkk">
            <h3>{{ ztSum }}</h3>
            <div>早退总次数</div>
        </div>
    </div>
    <div class="conTable">
        <el-table
        :data="list"
        border 
        height="430"
        style="width:100%;"
        >
            <el-table-column prop="name" min-width="200px" label="课程名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column width="80px" label="考勤结果" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.status === 1" style="color:green;">正常打卡</span>
                    <span v-else-if="scope.row.status === 2" style="color:red;">迟到</span>
                    <span v-else-if="scope.row.status == 0">未打卡</span>
                </template>
            </el-table-column>
            <el-table-column min-width="100px" label="考勤图片" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.status > 0">
                        <el-image 
                        style="width:100px;height:100px;cursor:pointer;"
                        :src="scope.row.img" 
                        :preview-src-list="[scope.row.img]">
                        </el-image>
                    </div>
                    <span v-else>暂无</span>
                </template>
            </el-table-column>
            <el-table-column width="100px" label="考勤时间" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.pushtime">{{scope.row.pushtime}}</span>
                    <span v-else>暂无</span>
                </template>
            </el-table-column>
            <el-table-column width="80px" label="早退结果" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.status2 === 1" style="color:green;">正常打卡</span>
                    <span v-else-if="scope.row.status2 === 2" style="color:red;">早退</span>
                    <span v-else-if="scope.row.status2 == 0">未打卡</span>
                </template>
            </el-table-column>
            <el-table-column min-width="100px" label="早退图片" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.status2 > 0">
                        <el-image 
                        style="width:100px;height:100px;cursor:pointer;"
                        :src="scope.row.img2" 
                        :preview-src-list="[scope.row.img2]">
                        </el-image>
                    </div>
                    <span v-else>暂无</span>
                </template>
            </el-table-column>
            <el-table-column width="100px" label="早退时间" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.pushtime2">{{scope.row.pushtime2}}</span>
                    <span v-else>暂无</span>
                </template>
            </el-table-column>
            <el-table-column width="100px" label="操作" align="center">
                <template slot-scope="scope">
                    <!-- <el-button v-if="scope.row.is_sgin && scope.row.is_sgin2 || scope.row.isqj" type="info" plain size="mini" disabled>申诉</el-button> -->
                    <el-button type="primary" plain size="mini" @click.prevent="appealFun(scope.row)">申诉</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination
        style="margin-top: 10px;"
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="handleCurrentUser"
        />
    </div>



    <!-- 考勤申诉 -->
    <el-dialog
    title="考勤申诉"
    :visible.sync="appealDlogState"
    :modal="true"
    width="600px"
    destroy-on-close
    v-if="appealDlogState"
    >
        <appealDlog :kqDataObj="kqDataObj" :dataState="dataState" :trainId="trainId" :courseId="courseId" @close="appealDlogState=false" ref="appealDom"></appealDlog>
        <div slot="footer">
            <el-button @click.prevent="appealDlogState = false">取 消</el-button>
            <el-button v-if="!dataState" @click.prevent="()=>{$refs.appealDom.submitFrom()}" type="primary">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Pagination from '@/components/Pagination'; //分页
import appealDlog from './appealDlog';
import {
    getCheckWorkList,
    getAlarmFree
} from '@/api/train/index';
export default {
    components:{
        Pagination,
        appealDlog
    },
    // props:['trainId'],
    data(){
        return {
            trainId: 0,
            kkSum: 0,
            cdSum: 0,
            qjSum: 0,
            ztSum: 0,
            list: [],
            listQuery:{
                page: 1,
                limit: 10,
            },
            total: 0,
            appealDlogState: false,
            courseId: 0,
            dataState: false,
            kqDataObj: null,
        }
    },
    created(){
        this.getList();
    },
    methods:{
        getList(){
            let info = JSON.parse(this.$store.state.User.infos);
            let para = {
                userId: info.id,
                idcard: info.idCard
            };
            getCheckWorkList(para).then(res=>{
                if(res.code == 200){
                    this.list = res.result || [];
                    this.kkSum = 0;
                    this.cdSum = 0;
                    this.qjSum = 0;
                    this.ztSum = 0;
                    this.list.forEach((item)=>{
                        if(item.status === 0){
                            this.kkSum++;
                        }else if(item.status === 2){
                            this.cdSum++;
                        }else if(item.status2 === 2){
                            this.ztSum++;
                        }
                    })
                }
            })
        },
        handleCurrentUser(val) {
            this.listQuery.page = val.page;
            this.listQuery.limit = val.limit;
            this.getList();
        },
        //申诉
        appealFun(row){
            let para = {
                userId: this.$store.state.User.ids,
                trainId: row.trainid,
                courseId: row.id,
            }
            getAlarmFree(para).then(res=>{
                if (res.result == null) {
                    this.kqDataObj = null;
                    this.dataState = false;
                } else {
                    this.kqDataObj = res.result;
                    this.dataState = true;
                }
            }).finally(()=>{
                this.trainId = row.trainid;
                this.courseId = row.id;
                this.appealDlogState = true;
            })
        }
    }
}
</script>

<style lang="less" scoped>
.kqCountDlogBox{
    .topCountHeader{
        display: flex;
        box-sizing: border-box;
        padding: 20px;
        .countkk{
            width: 100px;
            height: 100px;
            border: 2px solid transparent;
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 30px;
            &>h3{
                font-size: 24px;
            }
            &>div{
                font-size: 16px;
                margin-top: 5px;
            }
        }
        .countkk:nth-child(1){
            border-color: #fc1c1c;
            h3,div{
                color: #fc1c1c;
            }
        }
        .countkk:nth-child(2){
            border-color: #F56C6C;
            h3,div{
                color: #F56C6C;
            }
        }
        .countkk:nth-child(3){
            border-color: #409EFF;
            h3,div{
                color: #409EFF;
            }
        }
        .countkk:nth-child(4){
            border-color: #F59B25;
            h3,div{
                color: #F59B25;
            }
        }
    }

    .conTable{

    }
}
</style>